import { useCallback, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import useHexToRgb from "../../../AsianExchangeSrc/utils/useHexToRgb";
import { handleCancelPlaceBet } from "../../../AsianExchangeSrc/redux/slices/placeBetSlice";
import { useSearchParams } from "react-router-dom";
import { placeBet } from "../../../socketClient";
import {
  updateAvailableBalance,
  updateExposureBalance,
} from "../../../AsianExchangeSrc/redux/slices/userSlice";
import { toast } from "react-toastify";
import { addBet } from "../../../AsianExchangeSrc/redux/slices/accountSlice";
import { myBet } from "../../../AsianExchangeSrc/api";

function PlaceBet(props) {
  const {
    sportName,
    sportId,
    competitionId,
    eventId,
    market,
    markettype,
    marketId,
    selectedOdds,
    selectionId,
    isFancyBet = false,
    setActiveBet,
  } = props;
  const placeBetId = `${sportId}:${competitionId}:${eventId}:${marketId}:${market}:${markettype}:${selectionId}`;
  const [wantToPlaceBet, setWantToPlaceBet] = useState(false);
  const openPlaceBetId = useSelector((state) => state?.placeBet?.placeBetId);

  useEffect(() => {
    if (openPlaceBetId === placeBetId) {
      setWantToPlaceBet(true);
    } else {
      setWantToPlaceBet(false);
    }
    return () => {
      if (setActiveBet) {
        setActiveBet(null);
      }
    };
  }, [openPlaceBetId]);

  if (wantToPlaceBet) {
    return <BetBox {...props} />;
  }
  return null;
}

const BetBox = (props) => {
  const {
    selectedOdds,
    isFancyBet = false,
    selectedSize: betSize,
    backSize,
    laySize,
    setActiveBet,
    market,
    markettype,
    sportName,
    sportId,
    marketId,
    competitionId,
    selectionId,
    selection,
    suspendNow,
    runners,
    question,
  } = props;
  console.log({ props });
  const { betType } = useSelector((state) => state?.placeBet);
  const [searchParams] = useSearchParams();

  const eventName = searchParams.get("eventName");
  // const sportId = searchParams.get("eventType");
  const eventId = searchParams.get("eventId");
  // const competitionId = searchParams.get("competitionId");
  const joinedMarketIds = searchParams.get("joinedMarketIds");
  const dispatch = useDispatch();
  const betBoxBgColor = useSelector((state) => state?.placeBet?.betBoxBgColor);
  const rgbColor = useHexToRgb(betBoxBgColor);
  const [betPrice, setBetPrice] = useState(0);
  const [betStake, setBetStake] = useState(0);
  const [betData, setBetData] = useState(null);

  const handleCancel = () => {
    dispatch(handleCancelPlaceBet());
  };

  useEffect(() => {
    setBetPrice(selectedOdds);
    // return () => {
    //     handleCancel()
    // }
  }, [selectedOdds]);

  useEffect(() => {
    const createBetData = {
      type: betType,

      event: eventName,
      eventId: eventId,
      eventType: sportId,
      joinedMarketIds: joinedMarketIds,
      legueId: competitionId,
      market: market,
      marketId: marketId,
      markettype: markettype,
      matchId: eventId,
      oddsReq: selectedOdds,
      placeTime: new Date().toISOString(),
      runners: runners?.map(({ runnerName, runner, selectionId }) => ({
        [runnerName ? "runnerName" : "runner"]: runnerName
          ? runnerName
          : runner,
        selectionId,
      })),
      runnersCount: runners?.length,
      selection,
      selectionId: selectionId,
      // siteId: ,
      sportsName: sportName,
      stake: betStake,
    };
    if (markettype === "Bookmaker") {
      createBetData.favourMargin =
        betType === "Lay" ? betStake : (selectedOdds * Number(betStake)) / 100;
      createBetData.againstMargin =
        betType === "Back"
          ? -betStake
          : -((selectedOdds * Number(betStake)) / 100);
    }
    if (markettype === "Match Odds") {
      createBetData.favourMargin =
        betType === "Lay" ? betStake : (selectedOdds - 1) * Number(betStake);
      createBetData.againstMargin =
        betType === "Back"
          ? -betStake
          : -((selectedOdds - 1) * Number(betStake));
    }
    if (market === "Premium Cricket" && question) {
      createBetData.question = question;
    }
    if (markettype === "Fancy") {
      if (betPrice && betSize && betStake && betType) {
        const newSize = parseFloat(betSize) / 100;
        const pl = parseFloat(newSize) * parseFloat(betStake);
        let fancyProfit = 0.0;
        let fancyLoss = 0.0;
        if (betType === "Back") {
          fancyProfit = pl?.toFixed(2);
          fancyLoss = parseFloat(betStake)?.toFixed(2);
        } else if (betType === "Lay") {
          fancyProfit = parseFloat(betStake)?.toFixed(2);
          fancyLoss = pl?.toFixed(2);
        }
        // setBetData((prev) => ({
        //   ...prev,
        createBetData.favourMargin = fancyProfit;
        createBetData.againstMargin = fancyLoss;
        createBetData.stake = createBetData.stake.toString();
        createBetData.price = createBetData.oddsReq;
        createBetData.size = betSize;
        createBetData.backSize = backSize;
        createBetData.laySize = laySize;

        //   againstMargin: fancyLoss,
        //   sportsName: sport,
        // }));
      }
    }
    console.log({ createBetData });
    if (setActiveBet) {
      setActiveBet(createBetData);
    }
    setBetData(createBetData);
  }, [betPrice, betStake]);

  // Helpers
  const incrementValue = (val) =>
    val === 0 ? 1 : parseFloat((val + val * 0.05).toFixed(2));
  const decrementValue = (val) =>
    val === 0 ? 0 : Math.max(0, parseFloat((val - val * 0.05).toFixed(2)));
  const fetchBets = async () => {
    try {
      const response = await myBet();
      console.log("myBets", { response });

      dispatch(addBet(response?.data?.data?.slice().reverse() || []));
    } catch (error) {
      console.error("Error fetching bets:", error.message);
      dispatch(addBet([]));
      toast.error("Failed to fetch bets");
    }
  };
  const handlePlaceBet = async () => {
    const placeBetResponse = await placeBet({
      ...betData,
      againstMargin: Math.abs(betData?.againstMargin)?.toString(),
      legueId: betData.legueId.toString(),
      stake: betData.stake.toString(),
    });
    console.log({ placeBetResponse });
    if (!placeBetResponse.success) {
      toast.warning(placeBetResponse.message);
      return;
    }
    if (setActiveBet) {
      setActiveBet(null);
    }
    dispatch(
      updateAvailableBalance(placeBetResponse?.userData?.availableBalance)
    );
    dispatch(updateExposureBalance(placeBetResponse?.exposure));
    await fetchBets();
    toast.success(placeBetResponse.message);
    handleCancel();
  };

const [stakes, setStakes] = useState(() => {
  const savedStakes = localStorage.getItem("stakes");
  if (savedStakes) {
    try {
      const parsedStakes = JSON.parse(savedStakes);
      if (Array.isArray(parsedStakes)) {
        return parsedStakes;
      }
    } catch (err) {
      console.error("Failed to parse saved stakes:", err);
    }
  }

  return [
    { id: 1, buttonValue: "100" },
    { id: 2, buttonValue: "500" },
    { id: 3, buttonValue: "800" },
    { id: 4, buttonValue: "1000" },
    { id: 5, buttonValue: "5000" },
    { id: 6, buttonValue: "10000" },
    { id: 7, buttonValue: "50000" },
    { id: 8, buttonValue: "100000" },
  ];
});

  return (
    <div
      style={{ backgroundColor: `rgba(${rgbColor}, 0.6)` }}
      className={`border-b-2 border-gray-300 p-2 ${suspendNow}`}
      data-label="SUSPENDED"
    >
      <div className="w-full flex items-center space-x-2 mb-2">
        {!isMobile && (
          <button
            onClick={handleCancel}
            className="w-full flex flex-grow justify-center items-center py-2 bg-white text-black font-bold border rounded-md text-center text-xs h-[40px]"
          >
            Cancel
          </button>
        )}

        {/* Bet Price */}
        <div className="w-1/2 h-[40px] flex flex-grow justify-between items-center bg-white rounded-md border border-gray-400">
          <button
            className="h-[40px] w-[40px] px-2 py-1 text-blue-600 text-xl border-r border-gray-400"
            disabled={isFancyBet}
            onClick={() => setBetPrice((prev) => decrementValue(Number(prev)))}
          >
            −
          </button>
          <input
            name="betPrice"
            id="betPrice"
            type="number"
            className="px-2 text-gray-900 max-w-[25vw] text-center text-sm font-semibold"
            value={betPrice}
            min="0"
            onChange={(e) => setBetPrice(Math.max(0, Number(e.target.value)))}
            disabled={isFancyBet}
          />
          <button
            className="h-[40px] w-[40px] px-2 py-1 text-blue-600 text-xl border-l border-gray-400"
            onClick={() => setBetPrice((prev) => incrementValue(Number(prev)))}
            disabled={isFancyBet}
          >
            +
          </button>
        </div>

        {/* Bet Stake */}
        <div className="w-1/2 h-[40px] flex flex-grow justify-between items-center bg-white rounded-md border border-gray-400">
          <button
            className="h-[40px] w-[40px] px-2 py-1 text-blue-600 text-xl border-r border-gray-400"
            onClick={() => setBetStake((prev) => decrementValue(Number(prev)))}
          >
            −
          </button>
          <input
            name="betStake"
            id="betStake"
            type="number"
            className="px-2 text-gray-900 max-w-[25vw] text-center text-sm font-semibold"
            value={betStake}
            min="0"
            onChange={(e) => setBetStake(Math.max(0, Number(e.target.value)))}
          />
          <button
            className="h-[40px] w-[40px] px-2 py-1 text-blue-600 text-xl border-l border-gray-400"
            onClick={() => setBetStake((prev) => incrementValue(Number(prev)))}
          >
            +
          </button>
        </div>

        {!isMobile && (
          <button className="w-full flex flex-grow justify-center items-center p-2 bg-gradient-to-b from-black to-yellow-500 text-white font-bold rounded-md text-center text-xs text-nowrap h-[40px]">
            Place Bet
          </button>
        )}
      </div>

      {/* Quick Amount Buttons */}
      <div className="flex flex-wrap gap-2">
        {stakes?.map((amount) => (
          <button
            key={amount.buttonValue}
            className="bg-white border border-black rounded-md py-1 px-3 text-xs flex-grow basis-[calc(25%-0.5rem)] sm:basis-[calc(16.666%-0.5rem)]"
            onClick={() => setBetStake(amount.buttonValue)}
          >
            {amount.buttonValue}
          </button>
        ))}
      </div>

      <div className="w-full flex flex-row justify-between mt-2 gap-2">
        {isMobile && (
          <button
            onClick={handleCancel}
            className="flex-1 w-1/2 p-2 bg-white text-black font-bold border rounded-md text-xs border-black"
          >
            Cancel
          </button>
        )}
        {isMobile && (
          <button
            disabled={!betStake || !betPrice}
            className="flex-1 w-1/2 p-2 bg-aura-blue-gradient text-white font-bold rounded-md text-xs border border-black"
            onClick={() => {
              handlePlaceBet();
            }}
          >
            Place Bet
          </button>
        )}
      </div>
    </div>
  );
};

export default PlaceBet;
